import { claimOutbox } from "@/offline";
import { ChangePasswordScreen } from "@/screens/password/ChangePasswordScreen";
import { ShellLoading } from "@/screens/shell/ShellStates";
import { PinSetupScreen } from "@/screens/unlock/PinSetupScreen";
import type { ReactNode } from "react";
import { useEffect, useState } from "react";
import { completeSecretTenant, rememberedSecret } from "./relogin";
import { useSession } from "./session";
import { declinePinOffer, pinOfferArmed, useVault } from "./vault";

export function AccountGate({ children }: { children: ReactNode }) {
  const session = useSession();
  const { ownerKey, status, loading, refresh } = useVault();
  const [settled, setSettled] = useState(false);

  const tenantId = session.user.tenant_id;

  useEffect(() => {
    completeSecretTenant(tenantId);
    void claimOutbox(ownerKey);
  }, [ownerKey, tenantId]);

  if (session.must_change_password) {
    return <ChangePasswordScreen />;
  }

  if (loading) {
    return <ShellLoading />;
  }

  const secret = rememberedSecret();
  const label = session.user.display_name ?? session.user.email ?? "Tu cuenta";

  if (!status.saved && secret && !settled && pinOfferArmed(ownerKey)) {
    return (
      <PinSetupScreen
        ownerKey={ownerKey}
        secret={secret}
        label={label}
        onDone={() => {
          setSettled(true);
          refresh();
        }}
        onSkip={() => {
          declinePinOffer(ownerKey);
          setSettled(true);
        }}
      />
    );
  }

  return <>{children}</>;
}
